export const parseTemplateObject = (template) => {
  if (!template) return null;
  if (typeof template === 'string') {
    try {
      return JSON.parse(template);
    } catch {
      return null;
    }
  }
  return typeof template === 'object' ? template : null;
};

export const normalizePublicationBlock = (block) => {
  if (!block || typeof block !== 'object') return block;
  if (Array.isArray(block.block_content)) return block;
  if (Array.isArray(block.content)) {
    return { ...block, block_content: block.content };
  }
  return block;
};

export const isCardBlock = (block) => {
  if (!block || typeof block !== 'object') return false;
  const value = block.its_card;
  return value === 1 || value === '1' || String(value).trim() === '1';
};

const getCardBlockSlotsFromTemplate = (template) => {
  const parsed = parseTemplateObject(template);
  const blocks = parsed?.blocks;
  if (!Array.isArray(blocks)) return [];

  return blocks
    .map((block, index) => ({
      index,
      block_id: block?.block_id ?? index,
      isCard: isCardBlock(block),
    }))
    .filter((entry) => entry.isCard)
    .map(({ index, block_id }) => ({ index, block_id }));
};

export const isCardPublicationBlock = (block, index, template) => {
  const normalized = normalizePublicationBlock(block);
  if (isCardBlock(normalized)) return true;

  const parsed = parseTemplateObject(template);
  const templateBlocks = parsed?.blocks;
  if (Array.isArray(templateBlocks)) {
    const templateBlock = templateBlocks[index];
    if (templateBlock && isCardBlock(templateBlock)) return true;

    if (normalized?.block_id != null) {
      const templateMatch = templateBlocks.find(
        (tb, tbIndex) => String(tb?.block_id ?? tbIndex) === String(normalized.block_id),
      );
      if (templateMatch && isCardBlock(templateMatch)) return true;
    }
  }

  const cardSlots = getCardBlockSlotsFromTemplate(template);
  if (cardSlots.some((slot) => slot.index === index)) return true;

  if (normalized?.block_id != null) {
    return cardSlots.some((slot) => String(slot.block_id) === String(normalized.block_id));
  }

  return false;
};

export const findCardBlock = (contentData, template) => {
  if (!Array.isArray(contentData) || contentData.length === 0) return null;

  const normalizedContent = contentData.map(normalizePublicationBlock);

  const directMatch = normalizedContent.find(isCardBlock);
  if (directMatch) return directMatch;

  const cardSlots = getCardBlockSlotsFromTemplate(template);
  for (const slot of cardSlots) {
    const byBlockId = normalizedContent.find(
      (block) => block?.block_id != null && String(block.block_id) === String(slot.block_id),
    );
    if (byBlockId) return byBlockId;

    if (normalizedContent[slot.index]) {
      return normalizedContent[slot.index];
    }
  }

  return null;
};
